import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AumicoAbcpConfig, AumicoAbcpConfigService } from '../abcp-data.config';

/** What the closing settings show and change: the current business year and the closing's currency. */
export interface IClosingSettings {
    /** ISO `YYYY-MM-DD`. */
    periodStart: string | null;
    periodEnd: string | null;
    /** ISO 4217; null on a closing nobody has set it on yet. */
    currency: string | null;
}

/** Reads and writes the closing settings on the project — the same route every project update uses. */
@Injectable()
export class ClosingSettingsService {
    private readonly projectsEndpoint: string;

    public constructor(private readonly http: HttpClient, @Inject(AumicoAbcpConfigService) config: AumicoAbcpConfig) {
        this.projectsEndpoint = `${config.apiGateway}projects`;
    }

    public get(projectId: string): Observable<IClosingSettings> {
        return this.http
            .get<{ projectMetaData: Partial<Record<keyof IClosingSettings, string>> | null }>(
                `${this.projectsEndpoint}/${projectId}`,
            )
            .pipe(
                map(({ projectMetaData }) => ({
                    periodStart: projectMetaData?.periodStart ?? null,
                    periodEnd: projectMetaData?.periodEnd ?? null,
                    currency: projectMetaData?.currency ?? null,
                })),
            );
    }

    public save(projectId: string, settings: IClosingSettings): Observable<void> {
        return this.http.put(`${this.projectsEndpoint}/${projectId}`, settings).pipe(map(() => undefined));
    }
}
